module.exports = __webpack_public_path__ + "assets/img/banner-spy-mob.34deb3a0.webp";